<template>
  <div>
    <div class="cover_img_wrap">
      <div>封面图片(尺寸: 1600*1160)</div>
      <imageUpload v-model="project_icon" :limit="1" />
    </div>
    <div class="input-wrap">
      <label>案例标题</label>
      <el-input
        v-model="info.project_name"
        placeholder="请输入案例标题"
        class="input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>所属类别</label>
      <el-select v-model="info.project_type" placeholder="请选择" class="input">
        <el-option
          v-for="item in type_options"
          :key="item.type"
          :label="item.label"
          :value="item.type"
        >
        </el-option>
      </el-select>
    </div>
    <div class="input-wrap">
      <label>所属行业</label>
      <el-select v-model="info.class_uuid" placeholder="请选择" class="input">
        <el-option
          v-for="item in case_class"
          :key="item.uuid"
          :label="item.class_name"
          :value="`${item.id}`"
        >
        </el-option>
      </el-select>
    </div>
    <div class="input-wrap">
      <label>权重</label>
      <el-input
        type="number"
        v-model="info.sort"
        placeholder="0～99,越大越靠前"
        class="input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>副标题</label>
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="info.sub_title"
        class="input"
      >
      </el-input>
    </div>
    <div class="input-wrap">
      <label>产品类型</label>
      <el-select v-model="info.project_tag" placeholder="请选择" class="input">
        <el-option
          v-for="item in tags"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="input-wrap">
      <label>项目背景</label>
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="info.project_background"
        :rows="4"
        class="input"
      >
      </el-input>
    </div>
    <div class="big-client-info">
      <div class="left">
        <div class="input-wrap" v-if="info.project_type === '1'">
          <label>公司名称</label>
          <el-input
            v-model="info.company_name"
            placeholder="请输入公司名称"
            class="input"
          ></el-input>
        </div>
        <div v-if="info.project_type === '1'">
          <div>大客户banner图(尺寸: 1920*400)</div>
          <imageUpload v-model="big_project_banner" :limit="1" />
        </div>
      </div>
      <div>
        <div v-if="info.project_type === '1'">
          <div>首页轮播图(尺寸: 1680*912)</div>
          <imageUpload v-model="index_banner" :limit="1" />
        </div>
        <div v-if="info.project_type === '1'">
          <div>案例推荐图(尺寸: 1082*1500)</div>
          <imageUpload
            v-model="big_project_page_recommendation_img"
            :limit="1"
          />
        </div>
        <div>
          <div>logo(尺寸: 264*264)</div>
          <imageUpload v-model="big_project_logo" :limit="1" />
        </div>
      </div>
    </div>
    <!-- <div class="quill-wrap">
      <div>项目调研</div>
      <editor1 ref="editorSearch" id="search" value="#search"></editor1>
    </div>
    <div class="quill-wrap">
      <div>品牌调性</div>
      <wang-editor ref="editorBrand" id="brand" value="#brand"></wang-editor>
    </div> -->
    <div class="quill-wrap">
      <div>项目展示</div>
      <!-- <dankal-editor
        v-model="info.project_exhibition"
        :config="config"
        height="450px"
      /> -->
      <wang-editor
        ref="editorProject"
        id="project"
        value="#project"
      ></wang-editor>
    </div>
    <div class="btns-wrap">
      <el-button type="primary" @click="confirmClick">确认</el-button>
      <el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import imageUpload from "@/components/ImageUpload";
import Quill from "@/components/quill-editor";
import { mapState } from "vuex";
import { addCase, caseDetail, editCase } from "@/api/case-manage";
import DankalEditor from "@/components/editor/dankal-editor";
import Editor from "../../mixins/editor";
import WangEditor from "@/components/WangEditor";

export default {
  mixins: [Editor],
  data() {
    return {
      info: {
        project_name: "",
        project_type: "2",
        class_uuid: "",
        sort: "",
        project_background: "",
        sub_title: "",
        project_tag: "",
        project_icon: "",
        company_name: "",
        big_project_banner: "",
        index_banner: "",
        big_project_page_recommendation_img: "",
        big_project_logo: "",
        project_pesearch: "",
        project_brand: "",
        project_exhibition: "",
      },
      type_options: [
        { type: "1", label: "大客户案例" },
        { type: "2", label: "行业案例" },
      ],
      tags: [
        { label: "小程序", value: 1 },
        { label: "App", value: 2 },
        { label: "Web", value: 3 },
      ],
      handleType: "add",
      project_icon: [],
      big_project_banner: [],
      big_project_page_recommendation_img: [],
      big_project_logo: [],
      index_banner: [],
      details: "",
    };
  },
  computed: {
    ...mapState(["case_class"]),
  },
  components: {
    imageUpload,
    Quill,
    DankalEditor,
    WangEditor,
    editor1: WangEditor,
    editor2: WangEditor,
    editor3: WangEditor,
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.handleType = "edit";
      this.getCaseDetail(uuid);
    }
  },
  methods: {
    cancelClick() {
      this.$router.go(-1);
    },
    async confirmClick() {
      //把数组转为字符串
      this.info.project_icon = this.project_icon.join("");
      this.info.big_project_banner = this.big_project_banner.join("");
      this.info.big_project_page_recommendation_img = this.big_project_page_recommendation_img.join(
        ""
      );
      this.info.big_project_logo = this.big_project_logo.join("");
      this.info.index_banner = this.index_banner.join("");
      const {
        project_name,
        project_type,
        class_uuid,
        sort,
        project_background,
        sub_title,
        project_icon,
        company_name,
        big_project_banner,
        big_project_page_recommendation_img,
        big_project_logo,
        index_banner,
        project_tag,
      } = this.info;
      // const project_pesearch = this.$refs.editorSearch.getContent();
      // const project_brand = this.$refs.editorBrand.getContent();
      const project_exhibition = this.$refs.editorProject.getContent();
      // this.info.project_pesearch = project_pesearch;
      // this.info.project_brand = project_brand;
      this.info.project_exhibition = project_exhibition;
      if (!project_name) {
        this.$message("案例标题不能为空");
        return;
      }
      if (!class_uuid) {
        this.$message("请选择所属行业");
        return;
      }
      if (!sort) {
        this.$message("权重不能为空");
        return;
      }
      if (+sort < 0 || +sort > 99 || sort % 1 !== 0) {
        this.$message("权重必须为0～99之间的整数");
        return;
      }
      if (!project_background) {
        this.$message("项目背景不能为空");
        return;
      }
      if (!sub_title) {
        this.$message("副标题不能为空");
        return;
      }
      if (!project_background) {
        this.$message("项目背景不能为空");
        return;
      }
      if (!project_tag) {
        this.$message("请选择产品类型");
        return;
      }
      if (!project_icon) {
        this.$message("封面图片不能为空");
        return;
      }
      //大客户案例时
      if (project_type === "1") {
        if (!company_name) {
          this.$message("公司名称不能为空");
          return;
        }
        if (!big_project_banner) {
          this.$message("大客户banner图不能为空");
          return;
        }
        if (!big_project_page_recommendation_img) {
          this.$message("大客户首页推荐封面不能为空");
          return;
        }
        if (!big_project_logo) {
          this.$message("大客户logo不能为空");
          return;
        }
        if (!index_banner) {
          this.$message("首页轮播图不能为空");
          return;
        }
      }
      // if (!project_pesearch) {
      //   this.$message("项目调研不能为空");
      //   return;
      // }
      // if (!project_brand) {
      //   this.$message("品牌调性不能为空");
      //   return;
      // }
      if (!project_exhibition) {
        this.$message("项目展示不能为空");
        return;
      }
      if (this.handleType === "add") {
        const { status } = await addCase(this.info);
        if (status === 200) this.$router.go(-1);
      }
      if (this.handleType === "edit") {
        const { status } = await editCase(this.info);
        if (status === 200) this.$router.go(-1);
      }
    },
    async getCaseDetail(uuid) {
      const { data, status } = await caseDetail(uuid);
      if (status !== 200) return;
      this.info = data;
      this.project_icon = [data.project_icon];
      this.big_project_banner = [data.big_project_banner];
      this.index_banner = [data.index_banner];
      this.big_project_page_recommendation_img = [
        data.big_project_page_recommendation_img,
      ];
      this.big_project_logo = [data.big_project_logo];
      // this.$refs.editorSearch.setContent(data.project_pesearch);
      // this.$refs.editorBrand.setContent(data.project_brand);
      this.$refs.editorProject.setContent(data.project_exhibition);
    },
  },
};
</script>

<style lang="less" scoped>
.cover_img_wrap {
  float: right;
  margin-right: 100px;
  max-width: 400px;
  max-height: 300px;
}
.input-wrap {
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 10px;
  }
  .input {
    width: 400px;
  }
}
.big-client-info {
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  margin-right: 100px;
  padding: 10px;
  border: 1px solid #e5e5e5;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.quill-wrap {
  margin-top: 30px;
  margin-bottom: 50px;
}
.btns-wrap {
  display: flex;
  justify-content: center;
}
</style>
